<template>
  <div style="text-align: left;">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <van-image
          width="100%"
          height="100%"
          fit="contain"
          src="/static/images/img_signin.jpg"
        />
      </van-swipe-item>
    </van-swipe>

    <div style="padding-left: 15px;padding-right: 15px;">
      <van-steps :active="pageData.currentDayIndex" active-icon="star-o" color="#bfbfbf" active-color="#46C9BA">
        <van-step>
          <van-tag v-if="!pageData.day1" round type="success" color="#bfbfbf">1</van-tag>
          <van-tag v-else-if="pageData.day1" round type="success" color="#46C9BA">1</van-tag>
        </van-step>
        <van-step>
          <van-tag v-if="!pageData.day2" round type="success" color="#bfbfbf">2</van-tag>
          <van-tag v-else-if="pageData.day2" round type="success" color="#46C9BA">2</van-tag>
        </van-step>
        <van-step>
          <van-tag v-if="!pageData.day3" round type="success" color="#bfbfbf">3</van-tag>
          <van-tag v-else-if="pageData.day3" round type="success" color="#46C9BA">3</van-tag>
        </van-step>
        <van-step>
          <van-tag v-if="!pageData.day4" round type="success" color="#bfbfbf">4</van-tag>
          <van-tag v-else-if="pageData.day4" round type="success" color="#46C9BA">4</van-tag>
        </van-step>
        <van-step>
          <van-tag v-if="!pageData.day5" round type="success" color="#bfbfbf">5</van-tag>
          <van-tag v-else-if="pageData.day5" round type="success" color="#46C9BA">5</van-tag>
        </van-step>
        <van-step>
          <van-tag v-if="!pageData.day6" round type="success" color="#bfbfbf">6</van-tag>
          <van-tag v-else-if="pageData.day6" round type="success" color="#46C9BA">6</van-tag>
        </van-step>
        <van-step>
          <van-tag v-if="!pageData.day7" round type="success" color="#bfbfbf">7</van-tag>
          <van-tag v-else-if="pageData.day7" round type="success" color="#46C9BA">7</van-tag>
        </van-step>
      </van-steps>
    </div>
    <div style="text-align: center; padding-bottom: 15px;">
      <van-button v-if="!pageData.todaySignIn" color="#46C9BA" size="small" v-on:click="doSignIn">立即签到</van-button>
      <van-button v-else-if="pageData.todaySignIn" color="#46C9BA" size="small">今日已签到</van-button>
    </div>
    <van-panel title="每日签到礼包">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <van-cell v-for="item in pageData.items" key="index">
          <van-row type="flex" align="center">
            <van-col span="3">
              <van-image
                width="80%"
                height="80%"
                fit="contain"
                src="/static/images/icon_signin_gift.png"
              />
            </van-col>
            <van-col span="17">
              <div style="font-size: 12pt;">{{item.name}}({{item.count}}/{{item.conditionCount}})</div>
              <div style="font-size: 9pt;">{{item.desc}}.</div>
            </van-col>
            <van-col span="5">
              <van-button v-if="item.giftGeted" color="#6C6C6C" size="small">已领取</van-button>
              <van-button v-else-if="item.canGet" color="#46C9BA" size="small" v-on:click="doGetGift(item.ruleId)">领取
              </van-button>
              <van-button v-else-if="!item.canGet" color="#6C6C6C" size="small">
                未达标
              </van-button>
            </van-col>
          </van-row>
        </van-cell>
      </van-list>
    </van-panel>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        pageData: {},
        loading: false,
        finished: false,
      }
    },
    methods: {
      onLoad: function () {
        console.log('onload...')
        this.loadPageData()
      },
      //加载页面数据
      loadPageData: function () {
        let data = new FormData()
        let customerId = this.$route.query.customerId
        data.append('customerId', customerId)
        this.$axios.post('/api/activity/signin/sign-data', data).then(res => {
          if (res.data.success) {
            this.pageData = res.data.userObject
          } else {
            this.$toast.fail('加载失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
          this.finished = true
        }).catch(error => {
          this.finished = true
          this.$toast.fail('加载失败!')
        })
      },

      doSignIn: function () {
        let data = new FormData()
        let customerId = this.$route.query.customerId
        data.append('customerId', customerId)
        this.$axios.post('/api/activity/signin/do-signin', data).then(res => {
          if (res.data.success) {
            this.loadPageData()
            this.$toast.success('签到成功！')
          } else {
            this.$toast.fail('签到失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
          this.finished = true
        }).catch(error => {
          this.finished = true
          this.$toast.fail('签到失败!')
        })
      },
      doGetGift: function (ruleId) {
        let data = new FormData()
        let customerId = this.$route.query.customerId
        data.append('customerId', customerId)
        data.append('ruleId', ruleId)
        this.$axios.post('/api/activity/signin/do-getgift', data).then(res => {
          if (res.data.success) {
            this.loadPageData()
            this.$toast.success('领取成功！')
          } else {
            this.$toast.fail('领取失败，原因：' + res.data.msg + '!')
          }
          //加载状态结束
          this.finished = true
        }).catch(error => {
          this.finished = true
          this.$toast.fail('领取失败!')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/user/UserSignIn.vue